$shm_projects_tasks $mol_book2
	project_id \
	filter? \
	sort_by? \created
	sort_order? \desc
	pages <= task_pages /
	List $shm_projects_tasks_panel
		title \Задачи
		add_title \Добавить
		filter? <=> filter?
		sort_by? <=> sort_by?
		sort_order? <=> sort_order?
		add? <=> task_add? null
		task_rows <= task_rows /
		task_arg* <= task_arg* *
		task_title* <= task_title* \
		task_current* <= task_current* false
		task_is_new* false
	Empty $mol_view
		sub / \Задач нет
	Task* $shm_projects_task
		project_id <= project_id
		task_id <= task_id* \
